import(/* webpackMode: "eager" */ "/codebuild/output/src4179363947/src/patient-app/src/pages-client/homePage/HomePage.tsx");
